import { ENV_STORAGE_SUFFIX } from '../constants/apis'

// Keyed by org id, and org ids differ per region
const STORAGE_KEY = `insightsDrawerDismissed${ENV_STORAGE_SUFFIX}`

type DismissalMap = Record<string, { fingerprint: string }>

function readMap(): DismissalMap {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return {}
    }
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return {}
    }
    return parsed as DismissalMap
  } catch (e) {
    console.error('[insightsDismissalStorage] Failed to read', e)
    return {}
  }
}

function writeMap(map: DismissalMap): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map))
  } catch (e) {
    console.error('[insightsDismissalStorage] Failed to write', e)
  }
}

export const insightsDismissalStorage = {
  get(orgId: string | number): { fingerprint: string } | undefined {
    return readMap()[String(orgId)]
  },

  set(orgId: string | number, fingerprint: string): void {
    const map = readMap()
    map[String(orgId)] = { fingerprint }
    writeMap(map)
  },

  clear(orgId: string | number): void {
    const map = readMap()
    delete map[String(orgId)]
    writeMap(map)
  }
}

export function computeInsightsFingerprint(ids: string[]): string {
  return JSON.stringify([...ids].sort())
}
